<p-dropdown optionValue="id" optionLabel="label" [class]="{ disabled: readonly }" [required]="required" [options]="orgaosItens" [readonly]="readonly" [showClear]="true" [filter]="true" [resetFilterOnHide]="true" placeholder="Selecione..." (onChange)="onChangeCallback()" [formControlName]="formControlName" styleClass="mt-1">
    <ng-template pTemplate="filtericon">
        <span class="fas fa-search"></span>
    </ng-template>
    <ng-template pTemplate="clearicon">
        <span class="fas fa-times"></span>
    </ng-template>
    <ng-template pTemplate="dropdownicon">
        <span *ngIf="!readonly" class="fas fa-chevron-down"></span>
    </ng-template>
</p-dropdown>
